import { Tooltip, VisuallyHidden } from '@buffer-mono/popcorn'

import { formatNumber } from '../../utils'

import styles from './MetricNumber.module.css'

import type { JSX } from 'react'

interface MetricNumberProps {
  value: number
}

const TRUNCATION_THRESHOLD = 1_000

export function MetricNumber({ value }: MetricNumberProps): JSX.Element {
  const formatted = formatNumber(value)

  if (value < TRUNCATION_THRESHOLD) {
    return <>{formatted}</>
  }

  // Render the exact value via VisuallyHidden so assistive tech announces the
  // unabbreviated number (e.g. "466,632") and hide the truncated form from AT.
  // aria-label on a plain span is inconsistently exposed across screen readers.
  const exact = value.toLocaleString()
  return (
    <Tooltip content={exact}>
      <span className={styles.trigger}>
        <span aria-hidden="true">{formatted}</span>
        <VisuallyHidden>{exact}</VisuallyHidden>
      </span>
    </Tooltip>
  )
}
